(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["client-stories"] && !Shopify.designMode) return;
  try {
    

(() => {
 const instances=new Map();
 function init(root){
  if(instances.has(root))return;
  const track=root.querySelector('[data-stories-track]');if(!track)return;
  const cards=[...track.querySelectorAll('.story-card')],dots=[...root.querySelectorAll('[data-story-dot]')];
  const abort=new AbortController(),options={signal:abort.signal};
  const mobile=matchMedia('(max-width: 768px)'),reduced=matchMedia('(prefers-reduced-motion: reduce)');
  let frame=0;
  root.setAttribute('data-stories-enhanced','');
  const group=root.querySelector('[data-stories-dots]');if(group)group.hidden=false;
  function update(){
   frame=0;
   const bounds=track.getBoundingClientRect(),center=(bounds.left+bounds.right)/2;
   let nearest=0,distance=Infinity;
   cards.forEach((card,index)=>{
    const rect=card.getBoundingClientRect(),delta=Math.abs((rect.left+rect.right)/2-center);
    if(delta<distance){distance=delta;nearest=index;}
    const button=card.querySelector('[data-story-expand]'),paragraph=card.querySelector('.story-card__quote p');
    if(button&&paragraph)button.hidden=!mobile.matches||(!card.classList.contains('is-expanded')&&paragraph.scrollHeight<=paragraph.clientHeight+1);
   });
   dots.forEach((dot,index)=>{if(index===nearest)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');});
  }
  function schedule(){if(!frame)frame=requestAnimationFrame(update);}
  dots.forEach((dot,index)=>dot.addEventListener('click',()=>{
   const card=cards[index].getBoundingClientRect(),bounds=track.getBoundingClientRect();
   track.scrollBy({left:(card.left+card.right-bounds.left-bounds.right)/2,behavior:reduced.matches?'auto':'smooth'});schedule();
  },options));
  cards.forEach(card=>{const button=card.querySelector('[data-story-expand]');if(!button)return;button.addEventListener('click',()=>{
   const expanded=card.classList.toggle('is-expanded');button.setAttribute('aria-expanded',String(expanded));button.textContent=expanded?button.dataset.collapseLabel:button.dataset.expandLabel;schedule();
  },options);});
  track.addEventListener('scroll',schedule,{...options,passive:true});window.addEventListener('resize',schedule,options);
  const observer=typeof ResizeObserver==='function'?new ResizeObserver(schedule):null;if(observer)observer.observe(track);
  if(document.fonts)document.fonts.ready.then(()=>{if(!abort.signal.aborted)schedule();});
  instances.set(root,()=>{abort.abort();if(observer)observer.disconnect();cancelAnimationFrame(frame);root.removeAttribute('data-stories-enhanced');if(group)group.hidden=true;instances.delete(root);});
  schedule();
 }
 function scan(scope){if(scope.matches?.('[data-client-stories]'))init(scope);scope.querySelectorAll('[data-client-stories]').forEach(init);}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(document),{once:true});else scan(document);
 document.addEventListener('shopify:section:load',event=>scan(event.target));
 document.addEventListener('shopify:section:unload',event=>{instances.forEach((destroy,root)=>{if(event.target===root||event.target.contains(root))destroy();});});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-three-doors"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hero-doors-media')) {
  customElements.define('hero-doors-media', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.root = this.closest('.hero-doors');
      if (!this.root) return;
      this.root.addEventListener('change', event => {
        if (event.target.matches('.hero-doors__radio')) this.showSelected();
      }, { signal: this.abort.signal });
      this.showSelected();
    }
    showSelected() {
      const radio = Array.from(this.root.querySelectorAll('.hero-doors__radio')).find(input => input.checked);
      const slide = radio && document.getElementById(radio.getAttribute('aria-controls'));
      const template = slide?.querySelector('template[data-hero-picture]');
      if (template) template.replaceWith(template.content.cloneNode(true));
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-generic"]) return;
  try {
    
  if (!customElements.get('physical-product')) {
    customElements.define('physical-product', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        this.select = this.querySelector('[data-variant-select]');
        this.quantity = this.querySelector('[data-quantity]');
        this.submit = this.querySelector('[data-submit]');
        this.track = this.querySelector('[data-track]');
        this.thumbnails = this.querySelector('[data-thumbnails]');
        this.gallerySlides = this.track ? Array.from(this.track.children) : [];
        if (!this.select || !this.quantity || !this.submit) return;
        this.skuPicker = this.querySelector('[data-sku-picker]');
        if (this.skuPicker) {
          this.select.hidden = true;
          this.skuPicker.hidden = false;
          const label = this.querySelector('label[for="' + this.select.id + '"]');
          if (label) {
            label.id = this.select.id + '-label';
            this.skuPicker.setAttribute('aria-labelledby', label.id);
          }
          this.skuPicker.addEventListener('keydown', event => {
            if (event.key === 'Escape') {
              this.skuPicker.open = false;
              this.skuPicker.querySelector('summary').focus();
            }
            if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
              event.preventDefault();
              this.skuPicker.open = true;
              const options = Array.from(this.skuPicker.querySelectorAll('button:not(:disabled)'));
              const current = options.indexOf(document.activeElement);
              const next = event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1 : (current + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
              options[next]?.focus();
            }
          }, { signal: this.abort.signal });
          document.addEventListener('click', event => {
            if (!this.skuPicker.contains(event.target)) this.skuPicker.open = false;
          }, { signal: this.abort.signal });
          this.skuPicker.addEventListener('focusout', event => {
            if (!this.skuPicker.contains(event.relatedTarget)) this.skuPicker.open = false;
          }, { signal: this.abort.signal });
        }
        this.setAttribute('data-enhanced', '');
        this.setupMobileLayout();
        this.querySelectorAll('[data-quantity-step], [data-gallery-controls]').forEach(el => el.hidden = false);
        this.addEventListener('change', event => {
          if (event.target === this.select) this.updateVariant(true);
        }, { signal: this.abort.signal });
        this.addEventListener('click', event => {
          const deliveryLink = event.target.closest('a[href^="#ProductDelivery-"]');
          if (deliveryLink) document.getElementById(deliveryLink.hash.slice(1))?.querySelector('details')?.setAttribute('open', '');
          const button = event.target.closest('button');
          if (!button) return;
          if (button.dataset.skuValue && !button.disabled) {
            this.select.value = button.dataset.skuValue;
            this.select.dispatchEvent(new Event('change', { bubbles: true }));
            this.skuPicker.open = false;
            this.skuPicker.querySelector('summary').focus();
          }
          if (button.dataset.quantityStep) {
            const min = Number(this.quantity.min) || 1, step = Number(this.quantity.step) || 1;
            const max = this.quantity.max ? Number(this.quantity.max) : Infinity;
            const value = Number(this.quantity.value) || min;
            this.quantity.value = String(Math.max(min, Math.min(max, value + Number(button.dataset.quantityStep) * step)));
            this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
          }
          if (button.dataset.mediaTarget) this.showMedia(button.dataset.mediaTarget);
          if (button.dataset.thumbnailStep && this.thumbnails) {
            this.thumbnails.scrollBy({ top: Number(button.dataset.thumbnailStep) * this.thumbnails.clientHeight * .8, behavior: 'auto' });
            this.updateThumbnailControls();
          }
          if (button.dataset.galleryStep && this.track) {
            const slides = Array.from(this.track.children);
            const current = Math.round(this.track.scrollLeft / (this.track.clientWidth || 1));
            const next = (current + Number(button.dataset.galleryStep) + slides.length) % slides.length;
            if (slides[next]) this.showMedia(slides[next].dataset.mediaId);
          }
          if (button.hasAttribute('data-tray-submit') && !this.submit.disabled) this.submit.form.requestSubmit(this.submit);
        }, { signal: this.abort.signal });
        this.track?.addEventListener('scroll', () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.syncGallery(), 100);
        }, { passive: true, signal: this.abort.signal });
        this.updateVariant(false);
        this.thumbnails?.addEventListener('scroll', () => {
          if (!this.thumbnailFrame) this.thumbnailFrame = requestAnimationFrame(() => { this.thumbnailFrame = 0; this.updateThumbnailControls(); });
        }, { passive: true, signal: this.abort.signal });
        if (this.track && 'ResizeObserver' in window) {
          this.galleryObserver = new ResizeObserver(entries => {
            const {width, height} = entries[0].contentRect;
            if (width <= 0 || (width === this.galleryWidth && height === this.galleryHeight)) return;
            this.galleryWidth = width; this.galleryHeight = height;
            if (!this.hasAttribute('data-deck-layout')) this.querySelector('.physical-product__gallery').style.setProperty('--gallery-height', height + 'px');
            this.updateThumbnailControls();
            const active = this.querySelector('[data-media-target][aria-pressed="true"]');
            if (active) {
              cancelAnimationFrame(this.galleryFrame);
              this.galleryFrame = requestAnimationFrame(() => { this.galleryFrame = 0; this.showMedia(active.dataset.mediaTarget); });
            }
          });
          this.galleryObserver.observe(this.track);
        }
        if ('IntersectionObserver' in window && !this.hasAttribute('data-mobile-commerce')) {
          this.observer = new IntersectionObserver(entries => {
            const tray = this.querySelector('[data-tray]');
            if (tray) tray.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.bottom >= 0;
          });
          this.observer.observe(this.submit);
        }
      }
      setupMobileLayout() {
        if (this.hasAttribute('data-mobile-commerce')) return;
        const title = this.querySelector('.physical-product__purchase > h1');
        const gallery = this.querySelector('.physical-product__gallery');
        if (!title || !gallery || !window.matchMedia) return;
        if (!this.mobileLayout) {
          const titleHome = document.createTextNode('');
          title.before(titleHome);
          this.mobileLayout = () => {
            if (this.mobileQuery.matches) {
              gallery.before(title);
            } else {
              titleHome.after(title);
            }
          };
        }
        this.mobileQuery = window.matchMedia('(max-width: 59.99rem)');
        this.mobileQuery.addEventListener('change', this.mobileLayout, { signal: this.abort.signal });
        this.mobileLayout();
      }
      updateVariant(updateUrl) {
        const option = this.select.options[this.select.selectedIndex] || this.select.selectedOptions[0];
        if (!option) return;
        const data = option.dataset, available = data.available === 'true';
        if (this.skuPicker) {
          this.skuPicker.querySelector('[data-sku-name]').textContent = data.label || option.textContent;
          this.skuPicker.querySelector('[data-sku-price]').textContent = data.price;
          this.skuPicker.querySelectorAll('[data-sku-value]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.skuValue === option.value)));
        }
        this.querySelectorAll('span[data-price]').forEach(el => el.textContent = data.price);
        const compare = this.querySelector('s[data-compare]');
        if (compare) { compare.textContent = data.compare || ''; compare.hidden = !data.compare; }
        const unit = this.querySelector('p[data-unit], span[data-unit]');
        if (unit) { unit.textContent = data.unit || ''; unit.hidden = !data.unit; }
        this.querySelector('[data-stock]').textContent = available ? this.dataset.availableLabel : this.dataset.soldLabel;
        this.querySelectorAll('[data-submit], [data-tray-submit]').forEach(el => {
          el.disabled = !available; el.textContent = available ? this.dataset.addLabel : this.dataset.soldLabel;
        });
        const payment = this.querySelector('[data-payment]');
        if (payment) payment.hidden = !available;
        const min = Number(data.min) || 1, step = Number(data.step) || 1;
        this.quantity.min = String(min); this.quantity.step = String(step);
        if (data.max) this.quantity.max = data.max; else this.quantity.removeAttribute('max');
        const value = Math.max(min, Number(this.quantity.value) || min);
        this.quantity.value = String(Math.min(data.max ? Number(data.max) : Infinity, min + Math.ceil((value - min) / step) * step));
        if (data.media) this.showMedia(data.media);
        if (updateUrl) {
          const url = new URL(location.href); url.searchParams.set('variant', option.value);
          history.replaceState(history.state, '', url);
        }
      }
      hydrateGallery(index) {
        if (!this.track) return;
        const slide = this.gallerySlides[index], template = slide?.querySelector('template[data-gallery-image]');
        if (template) {
          const fragment = template.content.cloneNode(true);
          fragment.querySelectorAll('img').forEach(image => { image.loading = 'eager'; image.setAttribute('fetchpriority', 'auto'); });
          template.replaceWith(fragment);
        }
        const image = slide?.querySelector('img');
        if (image) image.loading = 'eager';
      }
      queueGalleryNeighbour(index) {
        this.neighbourAbort?.abort();
        clearTimeout(this.neighbourTimer);
        if (this.neighbourIdle && typeof cancelIdleCallback === 'function') cancelIdleCallback(this.neighbourIdle);
        this.neighbourIdle = 0;
        const next = this.gallerySlides[index + 1];
        if (!next?.querySelector('template[data-gallery-image]')) return;
        const abort = this.neighbourAbort = new AbortController();
        const preload = () => {
          if (abort.signal.aborted || !this.isConnected) return;
          const template = next.querySelector('template[data-gallery-image]');
          if (!template) return;
          const fragment = template.content.cloneNode(true);
          fragment.querySelectorAll('img').forEach(image => { image.loading = 'eager'; image.setAttribute('fetchpriority', 'low'); });
          template.replaceWith(fragment);
        };
        const schedule = () => {
          if (abort.signal.aborted) return;
          if (typeof requestIdleCallback === 'function') this.neighbourIdle = requestIdleCallback(preload, {timeout:1000});
          else this.neighbourTimer = setTimeout(preload, 100);
        };
        const image = this.gallerySlides[index]?.querySelector('img');
        if (!image || image.complete) schedule();
        else { image.addEventListener('load', schedule, {once:true, signal:abort.signal}); image.addEventListener('error', schedule, {once:true, signal:abort.signal}); }
      }
      showMedia(id) {
        if (!this.track) return;
        const slides = this.gallerySlides;
        const index = slides.findIndex(el => el.dataset.mediaId === String(id));
        if (index < 0) return;
        const left = index * (this.galleryWidth || this.track.clientWidth);
        this.syncGallery(index);
        if (Math.abs(this.track.scrollLeft - left) > 1) this.track.scrollTo({ left, behavior: 'auto' });
      }
      syncGallery(selectedIndex) {
        if (!this.track) return;
        const slides = this.gallerySlides;
        const index = selectedIndex ?? Math.round(this.track.scrollLeft / (this.galleryWidth || this.track.clientWidth || 1));
        const current = slides[Math.max(0, Math.min(index, slides.length - 1))];
        if (!current) return;
        const buttons = Array.from(this.querySelectorAll('[data-media-target]'));
        const active = buttons.find(el => el.dataset.mediaTarget === current.dataset.mediaId);
        let offset = 0, horizontal = true;
        if (active && this.thumbnails) {
          const outer = this.thumbnails.getBoundingClientRect(), inner = active.getBoundingClientRect();
          horizontal = getComputedStyle(this.thumbnails).flexDirection === 'row';
          offset = horizontal ? (inner.left < outer.left ? inner.left - outer.left : Math.max(0, inner.right - outer.right)) : (inner.top < outer.top ? inner.top - outer.top : Math.max(0, inner.bottom - outer.bottom));
        }
        this.updateThumbnailControls();
        this.hydrateGallery(slides.indexOf(current));
        buttons.forEach(el => { const pressed = String(el === active); if (el.getAttribute('aria-pressed') !== pressed) el.setAttribute('aria-pressed', pressed); });
        if (offset) this.thumbnails.scrollBy(horizontal ? { left: offset, behavior: 'auto' } : { top: offset, behavior: 'auto' });
        const status = this.querySelector('[data-gallery-status]');
        const label = `${slides.indexOf(current) + 1} / ${slides.length}`;
        if (status && status.textContent !== label) status.textContent = label;
        slides.filter(el => el !== current).forEach(el => el.querySelectorAll('video').forEach(video => video.pause()));
        if (this.neighbourIndex !== slides.indexOf(current)) { this.neighbourIndex = slides.indexOf(current); this.queueGalleryNeighbour(this.neighbourIndex); }
      }
      updateThumbnailControls() {
        const buttons = Array.from(this.querySelectorAll('[data-thumbnail-step]'));
        if (!this.thumbnails || !buttons.length) return;
        const vertical = getComputedStyle(this.thumbnails).flexDirection === 'column';
        const nav = this.thumbnails.parentElement;
        const contentHeight = this.thumbnails.scrollHeight;
        const overflow = vertical && contentHeight > nav.clientHeight + 1;
        const position = this.thumbnails.scrollTop, height = this.thumbnails.clientHeight;
        buttons.forEach(button => {
          const disabled = Number(button.dataset.thumbnailStep) < 0 ? position <= 1 : position + height >= contentHeight - 1;
          if (button.hidden !== !overflow) button.hidden = !overflow;
          if (button.disabled !== disabled) button.disabled = disabled;
        });
      }
      disconnectedCallback() {
        this.galleryObserver?.disconnect();
        this.neighbourAbort?.abort(); clearTimeout(this.neighbourTimer); this.neighbourIndex = null;
        if (this.neighbourIdle && typeof cancelIdleCallback === 'function') cancelIdleCallback(this.neighbourIdle);
        cancelAnimationFrame(this.galleryFrame); cancelAnimationFrame(this.thumbnailFrame);
        this.abort?.abort(); this.abort = null; this.observer?.disconnect(); clearTimeout(this.scrollTimer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
